import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=90acc3d2&scoped=true"
import script from "./Factory.vue?vue&type=script&lang=js"
export * from "./Factory.vue?vue&type=script&lang=js"
import style0 from "./Factory.vue?vue&type=style&index=0&id=90acc3d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90acc3d2",
  null
  
)

export default component.exports